import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { PopupHeader, RadioLabel, PopupFooter, Button } from '@gem/ui-kit';

import { useLanguageChangePopupPresenter } from './LanguageChangePopup.presenter';
import styles from './LanguageChangePopup.styles.m.css';

export const LanguageChangePopup: FC<ICommonPopupsProps> = observer((props) => {
  const { popupInstance } = props;
  const { t } = useTranslation();
  const presenter = useLanguageChangePopupPresenter();
  useClosePopupOnNavigation(popupInstance);

  return (
    <Popup
      isOpened
      isHidden={popupInstance.isHidden}
    >
      <PopupHeader
        title={t('admin_ui:language_title')}
        onClose={popupInstance.close}
      />
      <div className={styles.languageItems}>
        {presenter.languageItems.map((item) => {
          return (
            <RadioLabel
              key={item.key}
              value={item.value}
              onChange={(): void => item.onChange(item.value)}
              title={item.title}
              isActive={item.isActive}
            />
          );
        })}
      </div>
      <PopupFooter>
        <Button onClick={presenter.changeAppLanguage}>
          {t('admin_ui:language_save_and_reload')}
        </Button>
      </PopupFooter>
    </Popup>
  );
});
